import { getHideBellNotification } from "../../helpers";

const getMarketingMessage = (currentUser, ssrCookies = {}) => {
    return {
        hideBell: getHideBellNotification(ssrCookies),
        html: currentUser?.membership?.upsellHtml || ""
    };
};

export default getMarketingMessage;
